export const GET_COMPANIES__REQUEST = 'INTERNAL_COMPANY_TYPE__GET_COMPANIES__REQUEST'
export const GET_COMPANIES__SUCCESS = 'INTERNAL_COMPANY_TYPE__GET_COMPANIES__SUCCESS'
export const GET_COMPANIES__FAILURE = 'INTERNAL_COMPANY_TYPE__GET_COMPANIES__FAILURE'
export const CREATE_EMPLOYEE__REQUEST = 'INTERNAL_COMPANY_TYPE__CREATE_EMPLOYEE__REQUEST'
export const CREATE_EMPLOYEE__SUCCESS = 'INTERNAL_COMPANY_TYPE__CREATE_EMPLOYEE__SUCCESS'
export const CREATE_EMPLOYEE__FAILURE = 'INTERNAL_COMPANY_TYPE__CREATE_EMPLOYEE__FAILURE'
export const DELETE_EMPLOYEE__REQUEST = 'INTERNAL_COMPANY_TYPE__DELETE_EMPLOYEE__REQUEST'
export const DELETE_EMPLOYEE__SUCCESS = 'INTERNAL_COMPANY_TYPE__DELETE_EMPLOYEE__SUCCESS'
export const DELETE_EMPLOYEE__FAILURE = 'INTERNAL_COMPANY_TYPE__DELETE_EMPLOYEE__FAILURE'
